import * as THREE from "three"
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer"
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass"
import { FXAAShader } from "three/examples/jsm/shaders/FXAAShader"
import { SMAAPass } from "three/examples/jsm/postprocessing/SMAAPass"
// import { SubdivisionModifier } from "three/examples/jsm/modifiers/SubdivisionModifier"
import { init, gl, scene, camera, controls, create } from "./init/init"
// import gsap from "gsap"

import vertexShader from "./shaders/vertex.glsl"
import fragmentShader from "./shaders/fragment.glsl"
// import * as dat from "dat.gui";

// import bg from '../static/bg.png'

// const gltfLoader = new GLTFLoader()

import "./kursorStyle.css"
import "./style.css"
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass"
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass"

new kursor({
  type: 1,
})

init()

// let sphere = create(
//   "geo:plane:buffer",
//   [8, 8, 128, 128],
//   "shader",
//   {
//     vertexShader,
//     fragmentShader,
//     side: THREE.DoubleSide,
//     uniforms: {
//       uTime: { value: 0 },
//       uResolution: { value: new THREE.Vector2() },
//     },
//   },
//   ["elevation:position.y,-5,5,0.01", "wire:material.wireframe"]
// )

// let gui = new dat.GUI();

let sphere = create("geo:torus:buffer", [1, 0.3, 1300, 1300], "shader", {
  vertexShader,
  fragmentShader,
  side: THREE.DoubleSide,
  uniforms: {
    uTime: { value: 0 },
    uResolution: { value: new THREE.Vector2() },
    uDisplace: { value: 2 },
    uSpread: { value: 1.2 },
    uNoise: { value: 16 },
  },
})

// gui.add(sphere.material.uniforms.uDisplace , 'value' , 0 , 2 , .1).name('displacemnt')
// gui.add(sphere.material.uniforms.uSpread , 'value' , 0 , 2, .1).name('spread')
// gui.add(sphere.material.uniforms.uNoise , 'value' , 10, 25 , .1).name('noise')

// sphere.rotation.z = -Math.PI / 4

scene.add(sphere)

let composer = new EffectComposer(gl)
composer.addPass(new RenderPass(scene, camera))

const bloomPass = new UnrealBloomPass(
  new THREE.Vector2(window.innerWidth, window.innerHeight),
  1.4,
  0.0001,
  0.01
)
bloomPass.renderToScreen = true

composer.addPass(bloomPass)

// let fxaaPass = new ShaderPass( FXAAShader );
// fxaaPass.material.uniforms[ 'resolution' ].value.x = 1 / ( window.offsetWidth * gl.getPixelRatio() );
// fxaaPass.material.uniforms[ 'resolution' ].value.y = 1 / ( window.offsetHeight * gl.getPixelRatio() );

// composer.addPass(fxaaPass)

// post([sphere])

// let propObject = {
//   rotate:true
// };
// gui.add(propObject , 'rotate')

// let render
// if (composer) {
//   render = () => {
//     // bloom
//     renderBloom(true)
//     // render the entire scene, then render bloom scene on top
//     composer.render()
//   }
// } else {
//   render = () => {
//     gl.render(scene, camera)
//   }
// }
const clock = new THREE.Clock()

// sphere.material.uniforms.uResolution.value.x = gl.domElement.width
// sphere.material.uniforms.uResolution.value.y = gl.domElement.height

let animate = () => {
  const elapsedTime = clock.getElapsedTime()
  sphere.material.uniforms.uTime.value = elapsedTime
  sphere.rotation.z = Math.sin(elapsedTime) / 4 + elapsedTime / 20 + 5
  // render()
  composer.render()
  controls.update()
  requestAnimationFrame(animate)
}
animate()
